<template>
  <div class="scroll-hor-cont">
    <table class="form-calculadora">
      <tr class="form-titles">
        <th v-for="item in nombresCols">
          <p v-html="item"></p>
        </th>
      </tr>
      <tr v-for="(item, index) in formulario">
        <td>
          <p>
            <template v-if="item.nombre != 'Otro ¿cuál?'"> {{item.nombre}}  </template>
            <input v-if="item.nombre === 'Otro ¿cuál?'" :aria-label="item.nombre" name="Valor planeado" :placeholder="item.nombre" v-model="item.otro">
          </p>
        </td>
        <td class="input-td">
          <p><input type="number" :aria-label="item.nombre" name="Valor real" placeholder="Ingrese valor" v-model="item.valorUno"></p>
        </td>
        <td class="input-td">
          <p><input type="number" :aria-label="item.nombre" name="Valor planeado" placeholder="Ingrese valor" v-model="item.valorDos"></p>
        </td>
        <td>
          <p tabindex="0" :aria-label="'Diferencia mensual ' + resultadoDiferencia[index]" class="text-xs-center"><span class="font-red ">{{resultadoDiferencia[index]}}</span></p>
        </td>
      </tr>
      <tr>
        <td v-for="(item, index) in resultadoTotal">
          <p tabindex="0" class="text-xs-center"><span class="font-red ">{{index > 0?'$':''}}{{item}}</span></p>
        </td>
      </tr>
      <tr class="form-end" v-if="mostrarTotal">
        <td v-for="(item, index) in ingresosMasOtrosIngresos">
          <p tabindex="0" class="text-xs-center"><span class="font-red ">{{index > 0?'$':''}}{{item}}</span></p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    formulario: {
      type: Array,
      required: true
    },
    nombresCols:{
      type: Array,
      required: true
    },
    resultadoDiferencia: {
      type: Array,
      required: true
    },
    resultadoTotal: {
      type: Array,
      required: true
    },
    mostrarTotal: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {     
    };
  },
  computed:{
    ingresosMasOtrosIngresos(){
      return this.$store.getters.ingresosMasOtrosIngresos
    }
  }
};
</script>


<style lang="scss" scoped>
@import "../../sass/helpers/variables";
.form-calculadora {
  width: 100%;
  max-width: 1150px;
  min-width: 900px;
  margin: auto;
  border-collapse: collapse;
  padding: 10px;
  .form-titles {
    border-bottom: solid 2px #bbb;
  }
  .form-end{
    border-top: solid 2px #bbb;
  }
  .input-td {
    text-align: center;
  }
  tr {
    th,
    td {
      width: 25%;
      padding: 5px 10px;
      font-size: 1.2rem;
      line-height: 1.4rem;
      input {
        border: solid 1px $primary-red;
        text-align: center;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// FormCalculadora.vue?0278b474